import React from 'react';
import { Route } from 'react-router-dom';
import './mainwrap.scss';
import CIndustry from '../industry/cindustry.js';
import CTenet from '../tenet/ctenet.js';
import CSodToday from '../sodtoday/csodtoday.js';
import { renderRoutes } from 'react-router-config';
import CPrice from '../price/cprice.js';
import FoneVideo from '../fonevideo/fonevideo.jsx';
import '../customscroll/customscroll.scss';

export const Mainwrap = ({ route }) => {
  return (
    <div className='main-wrap'>

      <CTenet />
      <CSodToday />
      <CPrice />
      <CIndustry />
      {renderRoutes(route.routes)}
    </div>
  );
};




// WEBPACK FOOTER //
// ./src/client/components/main/mainwrap.jsx